




















import { Component, Mixins, Prop, Vue } from 'vue-property-decorator';
import { emailAddress } from '@/data';
import { UseFluid } from '@/mixins/UseFluid';

@Component({})
export default class ReachOut extends Mixins(UseFluid) {
  public action = `https://formspree.io/${emailAddress}`;
  public comment = '';
  public email = '';
  public name = '';
  public phoneNumber = '';
  public valid = null;
}
